"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalTipsDiv = exports.ModalHelpButton = exports.ModalHeaderTitleDiv = exports.ModalHeaderDiv = exports.ModalHeaderCancelButton = exports.ModalFooterDiv = exports.ModalContentDiv = exports.ModalButtonBarVerticalDiv = exports.ModalButtonBarHorizontalDiv = exports.ModalBodyDiv = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _variables = _interopRequireDefault(require("../constants/variables"));
var _ModalBackdrop = _interopRequireDefault(require("./ModalBackdrop"));
var _ModalWrapper = _interopRequireDefault(require("./ModalWrapper"));
var _Button = _interopRequireDefault(require("../Button"));
var _reactLion = _interopRequireDefault(require("@rosetta/react-lion"));
var _icons = require("../icons/react-icons/icons");
var _reduxUtils = require("@rosetta/redux-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ModalContentDiv = _styled["default"].div(function (props) {
  var styles = [{
    display: "flex",
    color: (0, _reduxUtils.extractPath)(props, "theme.modalContentText") || _variables["default"].modalContentText,
    paddingTop: "0px",
    paddingBottom: "0px",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%"
  }];
  if (props.gutter === true) {
    styles.push({
      paddingLeft: "100px",
      paddingRight: "100px"
    });
  } else {
    styles.push({
      paddingLeft: "0px",
      paddingRight: "0px"
    });
  }
  if (props.minPadding === true) {
    styles.push({
      paddingLeft: "10px",
      paddingRight: "10px"
    });
  }
  return styles;
});

// Header
exports.ModalContentDiv = ModalContentDiv;
var ModalHeaderDiv = _styled["default"].div(function (props) {
  var styles = [{
    display: "flex",
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    borderBottomColor: _variables["default"].lightGrey,
    paddingBottom: "30px",
    marginBottom: "30px",
    flexDirection: "row",
    flexGrow: "0"
  }];
  if (props.minPadding) {
    styles.push({
      paddingBottom: "10px",
      marginBottom: "10px"
    });
  } else {
    styles.push({
      paddingBottom: "25px",
      marginBottom: "25px"
    });
  }
  return styles;
});
exports.ModalHeaderDiv = ModalHeaderDiv;
var ModalHeaderTitleDiv = _styled["default"].div(function (props) {
  return {
    fontSize: "18pt",
    display: "flex",
    justifyContent: "center",
    color: (0, _reduxUtils.extractPath)(props, "theme.modalHeaderText") || _variables["default"].black,
    flexGrow: "1"
  };
});
exports.ModalHeaderTitleDiv = ModalHeaderTitleDiv;
var ModalHeaderCancelButton = _styled["default"].button({
  top: "10px",
  right: "20px",
  position: "absolute",
  borderWidth: 0,
  backgroundColor: "transparent",
  cursor: "pointer",
  ":focus": {
    outline: 0
  },
  flexGrow: "0",
  flexShrink: "0",
  fontSize: "large",
  height: "30px",
  width: "30px"
});

// Body
exports.ModalHeaderCancelButton = ModalHeaderCancelButton;
var ModalBodyDiv = _styled["default"].div({
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  flexShrink: "1",
  height: "100%"
});

// Footer
exports.ModalBodyDiv = ModalBodyDiv;
var ModalFooterDiv = _styled["default"].div({
  display: "flex",
  flexDirection: "column",
  flexShrink: "0",
  flexGrow: "0"
});
exports.ModalFooterDiv = ModalFooterDiv;
var ModalButtonBarHorizontalDiv = _styled["default"].div(function (props) {
  var styles = [{
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    flexGrow: "0",
    flexShrink: "0",
    justifyContent: "center",
    " & button + button": {
      marginLeft: "20px"
    }
  }];
  if (props.minPadding) {
    styles.push({
      paddingTop: "10px"
    });
  } else {
    styles.push({
      paddingTop: "25px"
    });
  }
  return styles;
});
exports.ModalButtonBarHorizontalDiv = ModalButtonBarHorizontalDiv;
var ModalButtonBarVerticalDiv = _styled["default"].div({
  display: "flex",
  paddingTop: "45px",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
  " & button + button": {
    marginTop: "10px"
  }
});
exports.ModalButtonBarVerticalDiv = ModalButtonBarVerticalDiv;
var ModalHelpButton = _styled["default"].div({
  border: "2px solid",
  borderColor: _variables["default"].lightGrey,
  borderRadius: "100%",
  background: _variables["default"].primary,
  height: "18px",
  width: "18px",
  fontSize: "10pt",
  margin: "5px",
  textAlign: "center",
  color: _variables["default"].white,
  cursor: "pointer"
});
exports.ModalHelpButton = ModalHelpButton;
var ModalTipsDiv = (0, _styled["default"])(_reactLion["default"].div)(function (props) {
  var style = {
    textAlign: "center",
    color: _variables["default"].primary,
    ":hover": {
      color: _variables["default"].primaryHover
    },
    ":hover:active": {
      color: _variables["default"].primaryActive
    },
    cursor: "pointer",
    marginTop: 10
  };
  if (props.disabled) {
    style.color = _variables["default"].lightGrey;
    style.pointerEvents = "none";
  }
  return style;
});
exports.ModalTipsDiv = ModalTipsDiv;
var ModalPrompt = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModalPrompt, _PureComponent);
  var _super = _createSuper(ModalPrompt);
  function ModalPrompt() {
    var _this;
    _classCallCheck(this, ModalPrompt);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderCancelAction", function (cancelAction) {
      if (cancelAction && !_this.props.hideAllCancelOptions) {
        return /*#__PURE__*/_react["default"].createElement(ModalHeaderCancelButton, {
          onClick: cancelAction,
          "data-qa": "ModalCloseIcon"
        }, /*#__PURE__*/_react["default"].createElement(_icons.MdCloseIcon, {
          color: "#4A4A4A",
          size: "30"
        }));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderHelpAction", function (helpAction) {
      if (helpAction) {
        return /*#__PURE__*/_react["default"].createElement(ModalHelpButton, {
          onClick: helpAction
        }, "?");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var cancelAction = _this.props.hideAllCancelOptions ? null : _this.props.cancelAction;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ModalBackdrop["default"], {
        click: cancelAction,
        showNavbar: _this.props.showNavbar,
        showTopNav: _this.props.showTopNav,
        showBottomNav: _this.props.showBottomNav
      }), /*#__PURE__*/_react["default"].createElement(_ModalWrapper["default"], {
        modalHeight: _this.props.modalHeight,
        modalWidth: _this.props.modalWidth,
        minPadding: _this.props.minPadding === true
      }, _this.renderCancelAction(_this.props.cancelAction), /*#__PURE__*/_react["default"].createElement(ModalContentDiv, {
        minPadding: _this.props.minPadding === true,
        "data-qa": _this.props.dataQa || "PromptDialog"
      }, _this.props.headerTitleKey ? /*#__PURE__*/_react["default"].createElement(ModalHeaderDiv, {
        minPadding: _this.props.minPadding === true
      }, /*#__PURE__*/_react["default"].createElement(ModalHeaderTitleDiv, null, /*#__PURE__*/_react["default"].createElement(_reactLion["default"].span, {
        lionkey: _this.props.headerTitleKey
      }), _this.renderHelpAction(_this.props.helpAction))) : "", /*#__PURE__*/_react["default"].createElement(ModalBodyDiv, {
        "data-qa": "PromptDialogPrompt"
      }, _this.props.messageKey && _this.props.messageKey.length > 0 ? /*#__PURE__*/_react["default"].createElement(_reactLion["default"].span, {
        lionkey: _this.props.messageKey,
        replacements: _this.props.messageReplacements
      }) : _this.props.exceptionMessage && _this.props.exceptionMessage.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", null, _this.props.exceptionMessage) : null, _this.props.children), /*#__PURE__*/_react["default"].createElement(ModalFooterDiv, null, _this.props.buttons && (_this.props.verticalButtons === true ? /*#__PURE__*/_react["default"].createElement(ModalButtonBarVerticalDiv, {
        minPadding: _this.props.minPadding === true
      }, _this.props.buttons.map(function (button) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
          key: button.labelKey || _this.getRandomKey(10000)
        }, button));
      })) : /*#__PURE__*/_react["default"].createElement(ModalButtonBarHorizontalDiv, {
        minPadding: _this.props.minPadding === true
      }, _this.props.buttons.map(function (button) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
          key: button.labelKey || _this.getRandomKey(10000)
        }, button));
      }))), !_this.props.hideTipsSection && _this.props.tipsLinkAction && _this.props.tipsLinkLionKey && /*#__PURE__*/_react["default"].createElement(ModalTipsDiv, {
        onClick: _this.props.tipsLinkAction,
        lionkey: _this.props.tipsLinkLionKey
      })))));
    });
    return _this;
  }
  _createClass(ModalPrompt, [{
    key: "getRandomKey",
    value: function getRandomKey(max) {
      return Math.floor(Math.random() * Math.floor(max));
    }
  }]);
  return ModalPrompt;
}(_react.PureComponent);
ModalPrompt.defaultProps = {
  hideTipsSection: true,
  messageReplacements: {},
  exceptionMessage: ""
};
ModalPrompt.propTypes = {
  hideAllCancelOptions: _propTypes["default"].bool,
  showNavbar: _propTypes["default"].bool,
  showTopNav: _propTypes["default"].bool,
  gutter: _propTypes["default"].bool,
  minPadding: _propTypes["default"].bool,
  dataQa: _propTypes["default"].string,
  modalHeight: _propTypes["default"].string,
  modalWidth: _propTypes["default"].string,
  // bottom most button section - for link with no background
  hideTipsSection: _propTypes["default"].bool,
  tipsLinkLionKey: _propTypes["default"].string,
  tipsLinkAction: _propTypes["default"].func,
  headerTitleKey: _propTypes["default"].string,
  cancelAction: _propTypes["default"].func,
  helpAction: _propTypes["default"].func,
  verticalButtons: _propTypes["default"].bool,
  messageKey: _propTypes["default"].string,
  messageReplacements: _propTypes["default"].object,
  exceptionMessage: _propTypes["default"].string,
  // in case messageKey is null

  buttons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    actionFunc: _propTypes["default"].func.isRequired,
    labelKey: _propTypes["default"].string,
    labelText: _propTypes["default"].string,
    buttonType: _propTypes["default"].string,
    disabled: _propTypes["default"]["boolean"]
  }))
};
var _default = ModalPrompt;
exports["default"] = _default;